const PokeAPIURL = "https://pokeapi.co/api/v2/pokemon/";

export default PokeAPIURL;